// Clamped collection description with an expand toggle. The clamp itself is
// CSS; this only decides whether the toggle is worth showing, which needs a
// measurement the server cannot make.
//
// Wrapped in an IIFE with a registry check because the script tag is emitted
// per block: a second copy on the page would otherwise redeclare the class.
(function () {
  if (customElements.get('collection-header-text')) return;

  class CollectionHeaderText extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-collection-header-text]');
      this.toggle = this.querySelector('[data-collection-header-toggle]');
      this.moreLabel = this.querySelector('[data-collection-header-more]');
      this.lessLabel = this.querySelector('[data-collection-header-less]');
      if (!this.text || !this.toggle) return;

      this.expanded = false;
      this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));
      this.syncToggle();

      // The line count depends on the rendered font and the column width, so
      // re-measure whenever either can have changed.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.syncToggle());
        this.resizeObserver.observe(this.text);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.syncToggle());
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    // Only meaningful while clamped: once expanded the toggle has to stay put
    // so the text can be collapsed again.
    syncToggle() {
      if (this.expanded) return;

      const overflows = this.text.scrollHeight > this.text.clientHeight + 1;
      // Guarded so the write cannot feed back into the ResizeObserver.
      if (this.toggle.hidden === !overflows) return;
      this.toggle.hidden = !overflows;
    }

    setExpanded(expanded) {
      this.expanded = expanded;
      this.classList.toggle('collection-header--expanded', expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      if (this.moreLabel) this.moreLabel.hidden = expanded;
      if (this.lessLabel) this.lessLabel.hidden = !expanded;
      if (!expanded) this.syncToggle();
    }
  }

  customElements.define('collection-header-text', CollectionHeaderText);
})();
